import { type AuthToken } from '@reliance/types/models/Auth';
import { type Inmate } from '@reliance/types/models/Inmate';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import {
  type ApiSuccessResponse,
  type ApiService,
  type QueryParams,
} from '../types/ApiService';
import config from '../services/config';

export const inmates = (
  centralApi: ApiService,
  getAuthToken: () => AuthToken,
) => ({
  index: (params: QueryParams = {}): Promise<PaginatedResponse<Inmate>> => {
    return centralApi.get('/inmate', {
      params: { ...params, preferCache: false },
    });
  },
  indexCentral: (
    params: QueryParams = {},
  ): Promise<PaginatedResponse<Inmate>> => {
    return centralApi.get('/inmate', { params: { ...params } });
  },
  get: function (id, params: QueryParams = {}): Promise<Inmate> {
    return centralApi.get(`/inmate/${id}`, { params });
  },
  post: function (data) {
    return centralApi.post('/inmate', data);
  },
  put: function (id, changes) {
    return centralApi.put(`/inmate/${id}`, changes);
  },
  delete: function (id, amount, note?) {
    return centralApi.delete(`/inmate/${id}`, { data: { amount, note } });
  },
  photoUrl: function (id) {
    return `${config.api.url}/inmate/photo/${id}?token=${
      getAuthToken().accessToken
    }&r=${new Date()}`;
  },
  pin: function () {
    return centralApi.get('/inmate/pin');
  },
  postMerge: (
    fromInmateId: number,
    toInmateId: number,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/inmate/merge', { fromInmateId, toInmateId });
  },
  clearFaceSignature: (id: number): Promise<ApiSuccessResponse<void>> => {
    return centralApi.delete(`/inmate/${id}/face/signature`);
  },
});
